/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Teal_Frog_SoarInputs */

const en_quiet_teal_frog_soar = /** @type {(inputs: Quiet_Teal_Frog_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Access`)
};

const de_quiet_teal_frog_soar = /** @type {(inputs: Quiet_Teal_Frog_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenzugriff`)
};

/**
* | output |
* | --- |
* | "Data Access" |
*
* @param {Quiet_Teal_Frog_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_teal_frog_soar = /** @type {((inputs?: Quiet_Teal_Frog_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Teal_Frog_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_teal_frog_soar(inputs)
	return de_quiet_teal_frog_soar(inputs)
});